import { CoreZonesReducer } from "./redux";
import { baseZonesApi } from "./redux/api";

export const ZonesCoreMiddlewares = [
  baseZonesApi.middleware,
];

export const ZonesCoreReducers = {
  [baseZonesApi.reducerPath]: baseZonesApi.reducer,
  CoreZonesReducer,
};